// extracted by mini-css-extract-plugin
module.exports = {"toggle":"ThemeToggle_toggle__2JtOx","circle":"ThemeToggle_circle__zgSt8","mask":"ThemeToggle_mask__A2ymg","path":"ThemeToggle_path__8IA_e"};